import { render, staticRenderFns } from "./TheSpaceAssignRolesDialog.vue?vue&type=template&id=32fe3ef7&"
import script from "./TheSpaceAssignRolesDialog.vue?vue&type=script&lang=js&"
export * from "./TheSpaceAssignRolesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports